export default {
  headline: 'Willkommen',
  welcomeText: process.env.VUE_APP_WELCOME_TEXT_DE ||
    'Herzlich Willkommen im Learning Management System von innovation mecom.'
}
